import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { dollarAmountNumberMask, parseInputValue, parseOutputValue } from './helpers';
import { delay } from 'lodash';
import MaskedInput from 'react-text-mask';
import { formatCurrency } from 'utils/formatCurrency';

const DollarInput = ({
  value: valueProp,
  onChange = (amount) => undefined,
  withForm = true,
  disabled,
}) => {
  const [text, setText] = useState('');
  const selectorRef = useRef(null);
  const inputSelectorRef = useRef(null);
  const textMeasureRef = useRef(null);
  const textPlaceholderRef = useRef(null);
  const inputRef = useRef(null);
  const value = text || parseInputValue(valueProp);
  useEffect(() => {
    if (!withForm) return;
    setText(parseInputValue(valueProp));
  }, [valueProp]);

  const setValue = (e) => {
    const numericValue = parseOutputValue(e.target.value);
    setText(e.target.value);
    onChange(numericValue);
  };
  const updateInputWidth = () => {
    if (textMeasureRef.current && inputRef.current) {
      const width = textMeasureRef.current.offsetWidth;
      inputRef.current.style.width = `${width}px`;
    }
    if (textPlaceholderRef.current && inputSelectorRef.current) {
      const width = textPlaceholderRef.current.offsetWidth;
      inputSelectorRef.current.style.width = `${width}px`;
    }
  };

  useLayoutEffect(() => {
    delay(() => updateInputWidth(), 100);
  }, []);

  useEffect(() => {
    updateInputWidth();
  }, [value]);

  const _onFocus = (e) => {
    if (selectorRef.current) selectorRef.current.classList.add('dollar-input-selector-focus');
  };

  return (
    <label ref={selectorRef} className='dollar-input-selector' aria-disabled={disabled} style={disabled ? { pointerEvents: 'none' } : {}}>
      <div ref={inputSelectorRef} style={{ position: 'relative', display: 'inline-flex', alignSelf: 'stretch', alignItems: 'center' }}>
        <MaskedInput
          mask={dollarAmountNumberMask}
          value={value}
          onChange={setValue}
          render={(textMaskRef, props) => {
            return (
              <input
                ref={ref => {
                  textMaskRef(ref);
                  // @ts-ignore
                  inputRef.current = ref;
                }}
                {...props}
                value={value}
                placeholder="$0"
                onFocus={_onFocus}
                onBlur={() => selectorRef.current?.classList.remove('dollar-input-selector-focus')}
                className='dollar-input-text'
              />
            );
          }}
        />
        <span className='dollar-input-text text-measure' ref={textMeasureRef} >{value || '$0'}</span>
        <span style={{ lineHeight: 'unset' }} ref={textPlaceholderRef} className='dollar-input-text text-placeholder' >{formatCurrency(value)}</span>
      </div>
    </label>
  )
}

export default DollarInput;
